module.exports = __webpack_public_path__ + "static/media/ebst.4c42eda0.svg";